import { render, staticRenderFns } from "./EntertainClientEditComponent.vue?vue&type=template&id=f7b96028"
import script from "./EntertainClientEditComponent.vue?vue&type=script&lang=js"
export * from "./EntertainClientEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports